module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 7-5876bcd032fbc0e3cef401aa48e39b32.webp";